import { useState } from 'react';
import { Button, Card, Inline, Stack, vars } from '@etg/wings';
import { css, mediaQueries } from '@eti/styles';
import { useTranslation } from '@eti/providers';
import ItineraryBound from '../../../../../order-details/components/overview/itinerary/drawer/ItineraryBound';
import type {
  RebookingTripBoundsType,
  RebookingTripSegmentsType,
  RebookingTripTypeType,
} from '../../../../../change-trip/models';
import type { BoundsType, SegmentsType } from '../../../../models';
import type { TripType } from '../model';

const buttonStyles = css`
  @media ${mediaQueries.small.only} {
    margin: auto;
  }
`;

const CardStyles = css`
  border: solid 1px ${vars.colors.divider};
  overflow: hidden;
  padding: 0;
`;

interface ItineraryDetailsProps {
  bounds: BoundsType | RebookingTripBoundsType;
  tripType: TripType | RebookingTripTypeType;
}

export const TripDetails = ({ bounds, tripType }: ItineraryDetailsProps) => {
  const { t } = useTranslation();
  const [showTripDetails, setShowTripDetails] = useState(false);
  const buttonLabel = showTripDetails
    ? t('Result.TripDetails.HideTripDetails.Button.Label')
    : t('Result.TripDetails.ShowTripDetails.Button.Label');

  return (
    <Stack data-testid="trip-details-wrapper">
      <Inline>
        <Button
          className={buttonStyles}
          data-testid="trip-details-button"
          onClick={() => setShowTripDetails(!showTripDetails)}
          size="small"
        >
          {buttonLabel}
        </Button>
      </Inline>

      {showTripDetails &&
        bounds.map(
          (bound, index) =>
            bound && (
              <Card
                className={CardStyles}
                data-testid={`trip-${bound.boundId}-details`}
                key={bound.boundId}
              >
                <ItineraryBound
                  boundId={bound.boundId}
                  boundIndex={index}
                  isSelected
                  journeyType={tripType}
                  segments={bound.segments as SegmentsType | RebookingTripSegmentsType}
                />
              </Card>
            ),
        )}
    </Stack>
  );
};
